import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Subject Confidentiality")
], -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "mb-6 d-flex flex-stack" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6" }, " 1. Will data identifying the subjects be made available to anyone (e.g., FDA, study sponsor) other than the Principal Investigator? ", -1)
const _hoisted_10 = { class: "form-check form-switch form-check-custom form-check-solid mb-6" }
const _hoisted_11 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_12 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_13 = {
  key: 0,
  class: "fs-6 fw-bold mb-6 required"
}
const _hoisted_14 = { class: "mb-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, [
  /*#__PURE__*/_createTextVNode("2. Where will the data be stored and for how long? "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "IRB requires data be stored a minimum of 3 years, but data can be stored longer."
  })
], -1)
const _hoisted_16 = { class: "mb-6 d-flex flex-stack" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6" }, [
  /*#__PURE__*/_createTextVNode(" 3. Will any identifiable information be collected from the subjects? "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Some examples of identifiable information include but not limited to: photographs, audio recordings, names, other information collected that can be used to identify a subject"
  })
], -1)
const _hoisted_18 = { class: "form-check form-switch form-check-custom form-check-solid mb-6" }
const _hoisted_19 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_20 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, [
  /*#__PURE__*/_createTextVNode("3.1. What are the identifiers that will be collected? "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "e.g., name, photograph, audio recordings, video recordings"
  })
], -1)
const _hoisted_22 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, "3.2. Who will have access to the identifiers? ", -1)
const _hoisted_24 = {
  key: 3,
  class: "mb-6"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, [
  /*#__PURE__*/_createTextVNode("3.3. When and how will you de-identify collected data? "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Definition: The ''de-identification process'' in human subject research involves removing or modifying identifying information from data to protect the anonymity and privacy of participants, ensuring that the data cannot be linked back to specific individuals.) (Explain timeline and who will be removing identifiers from data collected – for example, replacing names with pseudonyms or with a unique numeric identifier)"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_editor = _resolveComponent("editor")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("label", _hoisted_10, [
                _createVNode(_component_Field, {
                  type: "checkbox",
                  class: "form-check-input",
                  name: "q5_1",
                  value: "1",
                  modelValue: _ctx.step5.q5_1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step5.q5_1) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.step5.q5_1 == "1" ? "Yes" : "No"), 1)
              ])
            ]),
            (_ctx.step5.q5_1 == '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.step5.q5_1 == '1')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_13, " 1b. Please explain the data that will be made available and who will have access to the data, also include these in the Informed Consent: "))
                    : _createCommentVNode("", true),
                  _createVNode(_component_editor, {
                    for: "q5_2",
                    initialValue: "step5.q5_2",
                    modelValue: _ctx.step5.q5_2,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step5.q5_2) = $event)),
                    "api-key": _ctx.currentEditorToken,
                    licenseKey: "gpl",
                    init: {
                  height: 200,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
                }
                  }, null, 8, ["modelValue", "api-key"]),
                  (_ctx.step5.q5_1 == '1')
                    ? (_openBlock(), _createBlock(_component_Field, {
                        type: "hidden",
                        class: "form-control form-control-solid",
                        placeholder: "",
                        key: "q5_2",
                        name: "q5_2",
                        modelValue: _ctx.step5.q5_2,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step5.q5_2) = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.step5.q5_1 == '1')
                    ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                        key: 2,
                        name: "q5_2",
                        class: "fv-plugins-message-container invalid-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_editor, {
                for: "q5_3",
                initialValue: "step5.q5_3",
                modelValue: _ctx.step5.q5_3,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step5.q5_3) = $event)),
                "api-key": _ctx.currentEditorToken,
                licenseKey: "gpl",
                init: {
                  height: 200,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
                }
              }, null, 8, ["modelValue", "api-key"]),
              _createVNode(_component_Field, {
                type: "hidden",
                class: "form-control form-control-solid",
                placeholder: "",
                key: "q5_3",
                name: "q5_3",
                modelValue: _ctx.step5.q5_3,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step5.q5_3) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "q5_3",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("label", _hoisted_18, [
                _createVNode(_component_Field, {
                  type: "checkbox",
                  class: "form-check-input",
                  key: "q5_4",
                  name: "q5_4",
                  value: "1",
                  modelValue: _ctx.step5.q5_4,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step5.q5_4) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.step5.q5_4 == "1" ? "Yes" : "No"), 1)
              ])
            ]),
            (_ctx.step5.q5_4 == '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_editor, {
                    for: "q5_5",
                    initialValue: "step5.q5_5",
                    modelValue: _ctx.step5.q5_5,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step5.q5_5) = $event)),
                    "api-key": _ctx.currentEditorToken,
                    licenseKey: "gpl",
                    init: {
                  height: 200,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
                }
                  }, null, 8, ["modelValue", "api-key"]),
                  _createVNode(_component_Field, {
                    type: "hidden",
                    class: "form-control form-control-solid",
                    placeholder: "",
                    key: "q5_5",
                    name: "q5_5",
                    modelValue: _ctx.step5.q5_5,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step5.q5_5) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "q5_5",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.step5.q5_4 == '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_editor, {
                    for: "q5_6",
                    initialValue: "step5.q5_6",
                    modelValue: _ctx.step5.q5_6,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step5.q5_6) = $event)),
                    "api-key": _ctx.currentEditorToken,
                    licenseKey: "gpl",
                    init: {
                  height: 200,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
                }
                  }, null, 8, ["modelValue", "api-key"]),
                  _createVNode(_component_Field, {
                    type: "hidden",
                    class: "form-control form-control-solid",
                    placeholder: "",
                    key: "q5_6",
                    name: "q5_6",
                    modelValue: _ctx.step5.q5_6,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step5.q5_6) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "q5_6",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.step5.q5_4 == '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_editor, {
                    for: "q5_7",
                    initialValue: "step5.q5_7",
                    modelValue: _ctx.step5.q5_7,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.step5.q5_7) = $event)),
                    "api-key": _ctx.currentEditorToken,
                    licenseKey: "gpl",
                    init: {
                  height: 200,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
                }
                  }, null, 8, ["modelValue", "api-key"]),
                  _createVNode(_component_Field, {
                    type: "hidden",
                    class: "form-control form-control-solid",
                    placeholder: "",
                    key: "q5_7",
                    name: "q5_7",
                    modelValue: _ctx.step5.q5_7,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.step5.q5_7) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "q5_7",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}